import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import ReadMoreReadLess from './ReadMoreReadLess';
import { IoPerson } from 'react-icons/io5';
import { FaLinkedin } from 'react-icons/fa';

dayjs.extend(relativeTime);

export default function DocumentPost(props: any) {
  const { row, layout } = props;
  return (
    <idk-div>
      <idk-div class="zid-flex zid-gap-[10px] zid-justify-between zid-items-center zid-p-[10px]">
        <idk-div class="zid-flex-1 zid-flex zid-items-center zid-gap-2">
          <idk-div class="zid-rounded-full zid-overflow-hidden zid-bg-slate-300 zid-flex zid-items-center zid-justify-center zid-w-[32px] zid-h-[32px]">
            <IoPerson size={25} />
          </idk-div>
          <idk-div class="zid-flex zid-flex-col">
            <idk-p class="zid-m-0 zid-text-start zid-text-[14px] zid-font-[600] zid-text-[#141414]"></idk-p>
            <idk-p class="zid-m-0 zid-text-start zid-text-[10px] zid-text-[#141414]">
              {dayjs(row?.timestamp).fromNow()}
            </idk-p>
          </idk-div>
        </idk-div>
        <idk-div>
          <FaLinkedin size={25} color="#0762C8" />
        </idk-div>
      </idk-div>
      <idk-p>
        <ReadMoreReadLess totalWords={layout?.cardSettings?.descriptionWords}>{row.caption}</ReadMoreReadLess>
      </idk-p>
    </idk-div>
  );
}
